export enum ChatBotState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  WAITING = 'WAITING'
}

export enum ChatRoles {
  USER = 'user',
  SYSTEM = 'system',
  ASSISTANT = 'assistant'
}

export enum AiToneOptions {
  HUMOROUS = 'humorous',
  SASSY = 'sassy',
  COURT_JESTER = 'court jester',
  PIRATE = 'pirate',
  FUTURE_SELF = 'future self in twenty years',
  SCIENTIST = 'scientist',
  CHEERLEADER = 'cheerleader',
  UPBEAT = 'upbeat',
  FACTUAL = 'factual'
}
